import React, { useState } from "react";
import * as S from "./styles";
import ModalSettings from "../modalSettings";
import UserAvatar from "../userAvatar";
import { useUserContext } from "../../contexts/user/userContext";

const Header: React.FC = () => {
  const [showModal, setShowModal] = useState(false);
  const { state } = useUserContext();
  const { user } = state;

  return (
    <S.Container>
      <S.ImageContainer>
        <S.Image />
        <S.ProfileButton
          type="button"
          aria-label="Abrir perfil"
          onClick={() => setShowModal(true)}
        >
          {user ? (
            <UserAvatar
              name={user.name}
              code={user.code}
              avatar={user.avatar}
              size={40}
              light
            />
          ) : (
            <S.AvatarPlaceholder />
          )}
        </S.ProfileButton>
      </S.ImageContainer>
      <ModalSettings open={showModal} onClose={() => setShowModal(false)} />
    </S.Container>
  );
};

export default Header;
